const { ACTIVE_STORAGE_URL } = process.env;

export const getActiveStorageUrl = path => `${ACTIVE_STORAGE_URL}${path}`;

export const getDownloadUrl = url => {
  const newUrl = new URL(url);
  newUrl.searchParams.set('disposition', 'attachment');
  return newUrl.toString();
};
